/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  HostListener,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CmsParagraphComponent } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Subscription } from 'rxjs';

@Component({
  selector: 'cx-paragraph',
  templateUrl: './paragraph.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomParagraphComponent implements OnInit, OnDestroy {
  @HostBinding('class') hostClass = '';

  protected sanitizer = inject(DomSanitizer);
  subscription = new Subscription();

  @HostListener('click', ['$event'])
  public handleClick(event: Event): void {
    if (event.target instanceof HTMLAnchorElement) {
      const element = event.target as HTMLAnchorElement;
      const href = element?.getAttribute('href');
      const documentUrlObject = new URL(element.ownerDocument.URL);

      // Use router for internal link navigation
      if (href && documentUrlObject.host === element.host) {
        event.preventDefault();
        this.router.navigateByUrl(href.replace(documentUrlObject.origin, ''));
      }
    }
  }

  constructor(
    public component: CmsComponentData<CmsParagraphComponent>,
    protected router: Router,
  ) {}

  ngOnInit(): void {
    this.checkData();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  checkData() {
    this.subscription.add(
      this.component.data$.subscribe(component => {
        if (component.styleClasses) {
          this.hostClass = component.styleClasses;
        }
      }),
    );
  }

  public bypassSecurityTrustHtml(html: string = ''): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
